import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative flex flex-col min-h-screen">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AboutSection />
        <CarouselSection />
        <UpdatesSection />
        <CommentsSection />
        <TopicsSection />
        <IndexSection />
        <RankingSection />
        <FeaturesSection />
        <FaqSection />
        <CardsSection />
        <ContactSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}